import axios from 'axios';

const baseURL = `${process.env.REACT_APP_API_URL}`;

export const faqAPI = {
  add: async (info) => axios.post(`${baseURL}/faqs`, info).then((res) => res.data),
  all: async () => axios.get(`${baseURL}/faqs`).then((res) => res.data),
  single: async (idToSearch) => axios.get(`${baseURL}/single-faq/${idToSearch}`).then((res) => res.data),
  update: async (idToSearch) => {
    const { id, ...details } = idToSearch;
    return axios.put(`${baseURL}/single-faq/${id}`, details).then((res) => res.data);
  },
  delete: async (idToSearch) => axios.delete(`${baseURL}/single-faq/${idToSearch}`).then((res) => res.data)
};
